import type { SystemVersion } from '@repo/contracts';

import { apiClient } from '@/shared/api/axios';

export const getVersion = async (): Promise<SystemVersion> => {
  const response = await apiClient.get<SystemVersion>('/version');
  return response.data;
};
